import React from 'react';
import { ReactComponent as LoadingDroneWhite } from '../../../assets/svgs/LoadingDroneWhite.svg';
import { ArrowForward } from '@mui/icons-material';
import { Typography } from '@mui/material';

interface OrderCardActionProps {
  onClick: () => void;
  buttonText: string;
  iconComponent: JSX.Element;
}
export default function OrderCardAction(props: OrderCardActionProps): JSX.Element {
  return (<div style={{
    height: 42,
    paddingLeft: 16,
    paddingRight: 16,
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    background: '#0583FF',
    border: '1px solid rgba(255, 255, 255, 0.38)',
    borderRadius: '0px 0px 8px 8px'
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation()
    props.onClick();
  }}>
  <div style={{display: 'flex'}}>
    <div style={{
      marginRight: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {props.iconComponent}
    </div>
    <div>
      <Typography fontWeight={600} fontSize={12} color={'white'}>{props.buttonText}</Typography>
    </div>
  </div>

  <div>
    <ArrowForward fontSize='small' sx={{color: 'white'}} />
  </div>
</div>)
}
